import { all } from "@redux-saga/core/effects";
import formsSaga from "./forms/sagas";
import fieldsSaga from "./fields/sagas";
import collaboratorsSaga from "./collaborators/sagas";
import authSaga from "./auth/sagas";
import rulesSaga from "./logic/sagas";
import pagesSaga from "./pages/sagas";
import layoutSaga from "./layout/sagas";
import markers from "./markers/sagas";
import configs from "./configs/sagas";
import validations from "./validations/sagas";
import options from "./selectableOptions/sagas";
import UISaga from "./ui/sagas";
import paymentSaga from "./payment/sagas";
import SettingSaga from "./settings/sagas";
import chatSaga from "./chat/sagas";
import integrationsSaga from "./integrations/sagas";

export default function* rootSaga() {
    yield all([
        formsSaga(),
        fieldsSaga(),
        collaboratorsSaga(),
        authSaga(),
        rulesSaga(),
        pagesSaga(),
        layoutSaga(),
        markers(),
        configs(),
        validations(),
        UISaga(),
        options(),
        paymentSaga(),
        SettingSaga(),
        chatSaga(),
        integrationsSaga(),
    ]);
}
